import CareerHero from "../components/Career/CareerHero";
import CareerForm from "../components/Career/CareerForm";
export default function About() {
    return (
        <div>
            <CareerHero />
            <CareerForm />
        </div>
    );
}
